import { Component, OnInit, Input, ElementRef, AfterViewInit, ViewChildren, QueryList, NgZone, ChangeDetectorRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import { QuestElement, ModeQuestion, Option, GapFill, GapFillProposal } from '../../../models';

declare var $: any;

@Component({
  selector: 'Domino-Question',
  templateUrl: './DominoQuestion.component.html',
  styleUrls: ['./DominoQuestion.component.css', '../../questionnaire.component.css']
})

export class DominoQuestionComponent implements AfterViewInit, OnInit {

  constructor(private zone: NgZone,
    private element: ElementRef,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,) {
  }


  // #region Input
  ModeQuestion = ModeQuestion;
  mode: ModeQuestion;
  displayMode: boolean = false;
  firstLoad: boolean = true;
  deletedElement: Array<string>;
  questElement: QuestElement;
  pageId: number;
  gapsFillProposal: Array<GapFillProposal> = new Array<GapFillProposal>();
  proposalToAdd: string;
  odd: boolean = false;
  dominosTxt: string;
  @ViewChildren('dropZones') dropZones: QueryList<ElementRef>;
  @ViewChildren('dominos') dominos: QueryList<ElementRef>;
  @ViewChildren('proposals') proposals: QueryList<ElementRef>;

  @Output() GetMaxNote = new EventEmitter<boolean>();

  @Input() set PageId(value: number) {
    this.pageId = value;
  }

  @Input() set Mode(value: ModeQuestion) {
    this.mode = value;
    this.displayMode = this.mode == ModeQuestion.cDiplay || this.mode == ModeQuestion.rDiplay;
    if (!this.firstLoad) {

    } else {
      this.firstLoad = false;
    }
  }

  @Input() set QuestElement(value: QuestElement) {
    if (value != null) {
      this.questElement = value;
      if (this.questElement.options.length > 0) {
        this.gapsFillProposal = this.questElement.options[0].gapsFillProposal;
      }
    }
  }

  @Input() set DeletedElement(value: Array<string>) {
    if (value != null) {
      this.deletedElement = value;
    }
  }

  @Input() set Odd(value: boolean) {
    if (value) {
      this.odd = value;
    }
  }

  // #endregion



  ngOnInit() { }


  ngAfterViewInit() {
    if (this.mode == ModeQuestion.reply) {
      this.zone.runOutsideAngular(() => {
        this.dominos.forEach((dragEl: ElementRef) => this.addEventsDrag(dragEl));
        this.dropZones.forEach((dropEl: ElementRef) => this.addEventsDrop(dropEl));
      });
    }

    if (this.mode === ModeQuestion.create || this.mode === ModeQuestion.cDiplay) {
      this.sortProposal();
    } else {
      this.shuffleProposal();
    }
  }

  //#region DnD
  private addEventsDrag(el: ElementRef) {
    el.nativeElement.addEventListener('dragstart', this.onDragStart.bind(this));
    el.nativeElement.addEventListener('dragend', this.onDragEnd.bind(this));
    el.nativeElement.addEventListener('touchstart', this.onTouchStart.bind(this));
    el.nativeElement.addEventListener('touchmove', this.onTouchMove.bind(this));
    el.nativeElement.addEventListener('touchend', this.onTouchEnd.bind(this));
  }

  private addEventsDrop(el: ElementRef) {
    el.nativeElement.addEventListener('dragover', this.onDragOver.bind(this));
    el.nativeElement.addEventListener('drop', this.onDrop.bind(this));
    el.nativeElement.addEventListener('dragenter', this.onDragEnter.bind(this));
    el.nativeElement.addEventListener('dragleave', this.onDragLeave.bind(this));
    el.nativeElement.addEventListener('touchend', this.onTouchEndClick.bind(this));
  }
  onDragStart(event: any) {
    let dominos: string = event.target.getAttribute('domino')
    event.dataTransfer.setData('text', dominos);
    this.dropZones.forEach((drop) => { drop.nativeElement.classList.add('blinkingArea') });
  }


  onDragEnd(event: any) {
    this.dropZones.forEach((drop) => {
      drop.nativeElement.classList.remove('blinkingArea');
      drop.nativeElement.classList.remove('blinkingAreaHover');
    });
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  onDrop(event: any) {
    event.preventDefault();
    var data = event.dataTransfer.getData("text");
    let id: any = event.target.id.split("|");
    this.questElement.options[id[0]].gapsFill[id[1]].answer = data;
    this.cd.detectChanges();
  }

  onDragEnter(event: any) {
    event.target.classList.add('blinkingAreaHover');
  }

  onDragLeave(event: any) {
    event.target.classList.remove('blinkingAreaHover');
  }


  toucheStart: any;
  toucheMove: boolean;
  onTouchStart(event: any) {
   this.toucheStart = event
    let target: any = event.target;
    while (target.tagName != 'LI') {
      target = event.target.parentElement
    }
    this.dominosTxt = target.getAttribute('domino')
    this.dropZones.forEach((drop) => { drop.nativeElement.classList.add('blinkingArea') });
  }
  onTouchMove(event: any) {
    event.preventDefault();
    if (!this.toucheMove && Math.sqrt(Math.pow(this.toucheStart.touches[0].clientX - event.touches[0].clientX, 2) + Math.pow(this.toucheStart.touches[0].clientY - event.touches[0].clientY, 2))>20) {
      this.toucheMove = true;
    } 
  }

  onTouchEnd(event: any) {
    if (!this.toucheMove) { return }
    this.toucheMove = false;
      this.dropZones.forEach((drop) => {
        drop.nativeElement.classList.remove('blinkingArea');
        drop.nativeElement.classList.remove('blinkingAreaHover');

        let top = $(drop.nativeElement).offset().top;
        let topW = +top + 25;
        let left = $(drop.nativeElement).offset().left;
        let leftW = +left + 175;

        if (top <= event.changedTouches[0].clientY && event.changedTouches[0].clientY <= topW &&
          left <= event.changedTouches[0].clientX && event.changedTouches[0].clientX <= leftW) {

          let id: any = drop.nativeElement.id.split("|");
          this.questElement.options[id[0]].gapsFill[id[1]].answer = this.dominosTxt;
          this.cd.detectChanges();
        }

      });
    
  }


  onTouchEndClick(event: any) {
    if (this.toucheMove) { return }

    this.dropZones.forEach((drop) => {
      drop.nativeElement.classList.remove('blinkingArea');
      drop.nativeElement.classList.remove('blinkingAreaHover');
    });

    let id: any = event.target.id.split("|");
    this.questElement.options[id[0]].gapsFill[id[1]].answer = this.dominosTxt;
    this.cd.detectChanges();
  }
  //#endregion

  selectWord(index: number, pElement: QuestElement, pOption: Option, pOptionIndex: number): void {
    const selectGapWord: GapFill = pOption.gapsFill[index];

    //le mot est un trou s'il a des crochets et donc va passer en un mot normal, vice et versa 
    if (selectGapWord.isAnswer) {
      let nbUseElseWhere: number = 0;
      pElement.options.forEach(opt => {
        nbUseElseWhere += opt.gapsFill.filter(gap => gap.text == selectGapWord.text && gap.isAnswer).length;
      });
      //le mot c'est pas un trou dans d'autre phrase il est supprimer des propositions
      if (nbUseElseWhere == 1) {
        this.gapsFillProposal = this.gapsFillProposal.filter(prop => { return prop.text !== selectGapWord.text });
      }
      selectGapWord.isAnswer = false;
    } else {
      //push dans la liste des propositions
      this.pushInProposal(pOption.gapsFill[index].text);
      pOption.gapsFill[index].isAnswer = true;
    }



    // formatage du text en fonction des trous selectionnés 
    let newOptText: Array<string> = new Array<string>();
    pOption.gapsFill.forEach(gap => {
      if (gap.isAnswer) {
        newOptText.push(`[${gap.text}]`);
      } else {
        newOptText.push(gap.text);
      }
    });
    pOption.text = newOptText.join(' ');

    pElement.options.forEach((opt: Option) => {
      opt.gapsFillProposal = this.gapsFillProposal;
    });
    this.sortProposal();
  }

  generateGapOption(pOption: Option, pEvent: any, pOptionIndex: number): void {

    let allWords: GapFill[] = new Array<GapFill>();
    this.questElement.options.forEach(opt => { opt.gapsFill.forEach(gap => { allWords.push(gap) }) });

    //Old text
    let gapsFillOld: GapFill[] = new Array<GapFill>();
    if (pEvent) {
      gapsFillOld = this.sentenceToGap(pOption.text);
    }

    //New text
    pOption.gapsFill = this.sentenceToGap(pEvent);
    pOption.text = pEvent;
    //this.questElement.options[pOptionIndex] = pOption;

    if (gapsFillOld.length > 0) {
      let oldWords = gapsFillOld.filter(x => !pOption.gapsFill.includes(x));
      let newWords = pOption.gapsFill.filter(x => !gapsFillOld.includes(x));

      let oldWord: GapFill = new GapFill();
      let newWord: GapFill = new GapFill();
      for (let i: number = 0; i < oldWords.length; i++) {
        if (oldWords[i].text != newWords[i].text) {
          oldWord.text = oldWords[i].text;
          oldWord.isAnswer = oldWords[i].isAnswer;
          newWord.text = newWords[i].text;
          newWord.isAnswer = newWords[i].isAnswer;
        }
      }
      if (oldWord.text && newWord.text && newWord.isAnswer) {


        const oldWordIndex = this.gapsFillProposal.findIndex(gap => gap.text == oldWord.text);
        const newWordIndex = this.gapsFillProposal.findIndex(gap => gap.text == newWord.text);
        //si l'ancien mot n'est pas entre crochets on le rajoute s'il n'y ai pas deja sinon il passen en mode bonne réponse
        if (!oldWord.isAnswer) {
          if (this.gapsFillProposal.filter(x => x.text === newWord.text).length == 0) {
            this.pushInProposal(newWord.text);
          } else {
            this.gapsFillProposal[newWordIndex].isAnswer = true;
          }
        } else {

          const oldWordElseWhere: boolean = allWords.filter(x => x.text === oldWord.text && x.isAnswer).length > 1;
          // check si le nouveau mot n'est pas dans la liste des propositions
          if (newWordIndex < 0) {
            //si l'ancien mot est utilisé plusieurs fois on ajoute le nouveau sinon on remplace l'ancien par le nouveau
            if (oldWordElseWhere) {
              this.pushInProposal(newWord.text);
            } else {
              this.gapsFillProposal[oldWordIndex].text = newWord.text;
            }
          } else {
            // si le nouveau mot est déjà dans la liste des propositions et qu'il est en mode bonne réponse, on le supprime. S'il est en mode mauvaise réponse il passe en bonne réponse
            if (!oldWordElseWhere) {
              if (this.gapsFillProposal[newWordIndex].isAnswer) {
                this.gapsFillProposal.splice(oldWordIndex, 1);
              } else {
                this.gapsFillProposal[newWordIndex].isAnswer = true;
              }
            }
          }
        }
      }
    }

    this.generateGapProposal();
  }

  sentenceToGap(sentence: string): GapFill[] {
    let gapsFill: GapFill[] = new Array<GapFill>();
    const splitedText: string[] = sentence.split(' ');
    splitedText.forEach((word: string) => {
      const GF: GapFill = new GapFill();
      GF.text = word;
      if (GF.text.includes('[') && GF.text.includes(']')) {
        GF.text = GF.text.slice(1, -1);
        GF.isAnswer = true;
      }
      gapsFill.push(GF);
    });
    return gapsFill;
  }

  pushInProposal(newProposal: string): void {
    newProposal = newProposal;
    let gapInProposal = this.gapsFillProposal.find(prop => prop.text === newProposal)
    //check si le mot est deja dans la liste des dominos
    if (gapInProposal == undefined) {
      this.gapsFillProposal.push({ text: newProposal, isAnswer: true });
    } else if (gapInProposal.isAnswer == false) {
      gapInProposal.isAnswer = true;
    }
  }

  generateGapProposal(): void {
    let porposalGap: Array<string> = new Array<string>();
    this.questElement.options.forEach((opt: Option) => {
      const splitedText: string[] = opt.text.split(' ');
      splitedText.forEach((text: string) => {
        if (text.includes('[') && text.includes(']') && !porposalGap.includes(text.substring(1, text.length - 1))) {
          porposalGap.push(text.substring(1, text.length - 1));
        }
      });
    });

    for (let i: number = this.gapsFillProposal.length - 1; i >= 0; i--) {
      if (this.gapsFillProposal[i].isAnswer && !porposalGap.includes(this.gapsFillProposal[i].text)) {
        this.gapsFillProposal.splice(i, 1);
      }
    }
  }

  selectedWord(selectedWord: string): string {
    let result: string = ' ';
    if (selectedWord.includes('[') && selectedWord.includes(']')) {
      result = 'activeWord';
    }
    return result;
  }

  getMaxNote(): void {
    let pointMax: number = 0;
    this.questElement.options.forEach((opt: Option) => pointMax += opt.point ? +opt.point : 0);
    this.questElement.maxPoint = pointMax;
    this.GetMaxNote.emit(true);
  }

  addOption(pParent: any): void {
    // add option to an element
    const choix: Option = new Option;
    pParent.push(choix);
  }

  deleteOption(option: Option): void {
    this.questElement.options.splice(this.questElement.options.indexOf(option), 1);
    if (option.ident != '0') {
      this.deletedElement.push(option.ident);

      option.gapsFill.forEach((gap: GapFill) => {
        this.gapsFillProposal = this.gapsFillProposal.filter(prop => { return prop.text !== gap.text });
      });
    }
  }

  addProposal(): void {
    if (!this.proposalToAdd) { return };

    let proposalId = this.gapsFillProposal.findIndex(prop => prop.text == this.proposalToAdd)
    if (proposalId != -1) {
      this.renderer.addClass(this.proposals.toArray()[proposalId].nativeElement, 'shake');
      setTimeout(() => { this.renderer.removeClass(this.proposals.toArray()[proposalId].nativeElement, 'shake');},1000)
      return;
    }

   
      this.gapsFillProposal.push({ text: this.proposalToAdd, isAnswer: false });
      this.proposalToAdd = '';
      this.questElement.options.forEach((opt: Option) => {
        opt.gapsFillProposal = this.gapsFillProposal;
      });
      this.sortProposal();
   
  }

  DeleteProposal(proposal: string): void {
    this.gapsFillProposal = this.gapsFillProposal.filter(prop => prop.text != proposal);

    this.questElement.options[0].gapsFillProposal = this.gapsFillProposal;
  }

  sortProposal() {
    this.gapsFillProposal = this.gapsFillProposal.sort((a, b) => { return (a.isAnswer === b.isAnswer) ? 0 : a.isAnswer ? -1 : 1; });
  }

  shuffleProposal() {
    var currentIndex = this.gapsFillProposal.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {

      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = this.gapsFillProposal[currentIndex];
      this.gapsFillProposal[currentIndex] = this.gapsFillProposal[randomIndex];
      this.gapsFillProposal[randomIndex] = temporaryValue;
    }
  }
}
